<template>
  <div class="OdontogramaForm">
    <v-dialog
      v-model="showDialogForm"
      fullscreen
      scrollable
    >
      <v-card
        :loading="cargando"
        :disabled="cargando"
      >
        <v-card-title v-text="'Registrar cambios en el odontograma'" />
        <v-card-text>
          <v-row>
            <v-col
              cols="12"
              sm="6"
            >
              <h2 class="mb8">Superior Izquierdo</h2>
              <div
                v-for="n in 8"
                :key="n"
              >
                <v-text-field
                  class="mt24"
                  :label="'1' + n"
                  v-model="odontograma['si' + n + '_odo']"
                  filled
                  append-icon="add_shopping_cart"
                  @click:append="dienteToAdd = 'si' + n"
                />
                <span
                  v-for="(ood,idxood) in odontoCart['si' + n]"
                  :key="idxood"
                  v-if="odontoCart['si' + n] && odontoCart['si' + n].length > 0"
                  class="cart-service"
                >
                  {{ood.cant_sca}} x {{ood.desc_ser}}: {{$nF(ood.cant_sca*ood.precio_sca)}}
                  {{idxood+1>=odontoCart['si' + n].length? '':','}}
                </span>
                <v-divider></v-divider>
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <h2 class="mb8">Superior Derecho</h2>
              <div
                v-for="n in 8"
                :key="n"
              >
                <v-text-field
                  class="mt24"
                  :label="'2' + n"
                  v-model="odontograma['sd' + n + '_odo']"
                  filled
                  append-icon="add_shopping_cart"
                  @click:append="dienteToAdd = 'sd' + n"
                />
                <span
                  v-for="(ood,idxood) in odontoCart['sd' + n]"
                  :key="idxood"
                  v-if="odontoCart['sd' + n] && odontoCart['sd' + n].length > 0"
                  class="cart-service"
                >
                  {{ood.cant_sca}} x {{ood.desc_ser}}: {{$nF(ood.cant_sca*ood.precio_sca)}}
                  {{idxood+1>=odontoCart['sd' + n].length? '':','}}
                </span>
                <v-divider></v-divider>
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <h2 class="mb8">Inferior izquierdo</h2>
              <div
                v-for="n in 8"
                :key="n"
              >
                <v-text-field
                  class="mt24"
                  :label="'4' + n"
                  v-model="odontograma['ii' + n + '_odo']"
                  filled
                  append-icon="add_shopping_cart"
                  @click:append="dienteToAdd = 'ii' + n"
                />
                <span
                  v-for="(ood,idxood) in odontoCart['ii' + n]"
                  :key="idxood"
                  v-if="odontoCart['ii' + n] && odontoCart['ii' + n].length > 0"
                  class="cart-service"
                >
                  {{ood.cant_sca}} x {{ood.desc_ser}}: {{$nF(ood.cant_sca*ood.precio_sca)}}
                  {{idxood+1>=odontoCart['ii' + n].length? '':','}}
                </span>
                <v-divider></v-divider>
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <h2 class="mb8">Inferior derecho</h2>
              <div
                v-for="n in 8"
                :key="n"
              >
                <v-text-field
                  class="mt24"
                  :label="'3' + n"
                  v-model="odontograma['id' + n + '_odo']"
                  filled
                  append-icon="add_shopping_cart"
                  @click:append="dienteToAdd = 'id' + n"
                />
                <span
                  v-for="(ood,idxood) in odontoCart['id' + n]"
                  :key="idxood"
                  v-if="odontoCart['id' + n] && odontoCart['id' + n].length > 0"
                  class="cart-service"
                >
                  {{ood.cant_sca}} x {{ood.desc_ser}}: {{$nF(ood.cant_sca*ood.precio_sca)}}
                  {{idxood+1>=odontoCart['id' + n].length? '':','}}
                </span>
                <v-divider></v-divider>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            v-text="'Cancelar'"
            @click="showDialogForm = false"
          />
          <v-btn
            class="primary"
            v-text="'Guardar'"
            @click="_checkHowToSaveOdontograma"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      width="400"
      v-model="showDialogAddToCart"
    >
      <v-card
        :loading="cargando"
        :disabled="cargando"
      >
        <v-card-title v-text="'Añadir servicios al diente'" />
        <v-card-text>
          <autocomplete-servicios
            v-model="cart.id_ser_sca"
            @change="_handleServicioChange"
          />
          <v-text-field
            filled
            label="Cantidad"
            v-model="cart.cant_sca"
            type="number"
            min="1"
          />

          <v-text-field
            filled
            label="Precio unitario"
            prepend-inner-icon="attach_money"
            v-model="cart.precio_sca"
          />
          <v-btn
            class="primary"
            @click="_addCarritoDiente"
          >
            <v-icon>add</v-icon>Agregar
          </v-btn>
        </v-card-text>
        <v-list v-if="odontoCart[dienteToAdd] && odontoCart[dienteToAdd].length>=1">
          <div
            v-for="(od,idxo) in odontoCart[dienteToAdd]"
            :key="idxo"
          >
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title v-text="od.desc_ser+' '+$nF(od.cant_sca*od.precio_sca)" />
                <v-list-item-subtitle>
                  <v-text-field
                    v-model="od.cant_sca"
                    type="number"
                    min="1"
                    dense
                    hide-details
                    style="max-width: 80px;"
                    @change="_updateServiceQuantity(idxo)"
                  />
                  <span class="ml-2">Precio unitario: {{$nF(od.precio_sca)}}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  icon
                  @click="_deleteCarrito(idxo)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </div>
        </v-list>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            v-text="'Cerrar'"
            @click="showDialogAddToCart=false"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      width="400"
      v-model="showDialogConfirmCart"
    >
      <v-card
        :loading="cargando"
        :disabled="cargando"
      >
        <v-card-title>¿Está correcto el carrito?</v-card-title>
        <v-list>
          <div
            v-for="(fc,idxfc) in finalCart"
            :key="idxfc"
          >
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title v-text="fc.cant_sca+' x '+fc.desc_ser" />
              </v-list-item-content>
              <v-list-item-action-text v-text="$nF(fc.cant_sca*fc.precio_sca)" />
            </v-list-item>
            <v-divider />
          </div>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                <strong> Total: {{$nF(total)}} </strong>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider />
        </v-list>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            v-text="'No'"
            @click="showDialogConfirmCart=false"
          />
          <v-btn
            class="primary"
            v-text="'Si, guardar'"
            @click="_guardarOdontograma"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import forms from "@/mixins/forms.js";
import AutocompleteServicios from "@/components/forms/autocompletes/AutocompleteServicios.vue";
export default {
  name: "OdontogramaForm",
  mixins: [forms],
  components: { AutocompleteServicios },
  props: {
    value: Boolean,
    paciente: String,
    odontogramaToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      odontograma: {
        id_odo: null,
        id_pac_odo: null,
        id_usr_odo: null,
        fecha_odo: null,
      },
      odontoCart: {},
      finalCart: [],
      showDialogForm: false,
      showDialogAddToCart: false,
      showDialogConfirmCart: false,
      cart: {
        id_pac_sca: null,
        id_ser_sca: null,
        cant_sca: null,
        precio_sca: null,
        desc_ser: null,
        diente: null,
      },
      dienteToAdd: null,
    };
  },
  methods: {
    _checkHowToSaveOdontograma() {
      this.finalCart.length >= 1
        ? (this.showDialogConfirmCart = true)
        : this._guardarOdontograma();
    },
    _guardarOdontograma() {
      this.odontograma.id_pac_odo = this.paciente;
      
      // Guardar el carrito en cada diente
      ['si', 'sd', 'ii', 'id'].forEach(sector => {
        for (let i = 1; i <= 8; i++) {
          const diente = sector + i;
          if (this.odontoCart[diente] && this.odontoCart[diente].length > 0) {
            this.odontograma[diente + '_cart_odo'] = JSON.stringify(this.odontoCart[diente]);
          } else {
            this.odontograma[diente + '_cart_odo'] = null;
          }
        }
      });

      const data = { 
        odontograma: this.odontograma, 
        carrito: this.finalCart 
      };
      
      // Si estamos editando, usar el endpoint de actualización, si no, usar el de creación
      if (this.odontogramaToEdit && this.odontogramaToEdit.id_odo) {
        // Para actualización
        this.odontograma.id_odo = this.odontogramaToEdit.id_odo;
        this._saveAll(
          `odontograma/${this.odontogramaToEdit.id_odo}`,
          data,
          "msg",
          "_handleOdontogramaResponse"
        );
      } else {
        // Para creación
        this._saveAll(
          "odontograma",
          data,
          "msg",
          "_handleOdontogramaResponse"
        );
      }
    },
    _handleOdontogramaResponse(res) {
      console.log('Respuesta del guardado:', res);
      this.$emit("updated", true);
      this.$emit("input", false);
      this.$emit("msg", res.msg || "Odontograma guardado correctamente");
      this._resetForm();
    },
    _resetForm() {
      this.showDialogForm = false;
      this.showDialogAddToCart = false;
      this.showDialogConfirmCart = false;
      this._createCleanOdontograma();
      this._limpiarCart();
      this.finalCart = [];
      this.dienteToAdd = null;
    },
    _createCleanOdontograma() {
      // Reiniciar el odontograma con campos base
      this.odontograma = {
        id_odo: null,
        id_pac_odo: null,
        id_usr_odo: null,
        fecha_odo: null,
      };
      
      // Reiniciar el carrito y los campos de cada diente
      this.odontoCart = {};
      ['si', 'sd', 'ii', 'id'].forEach(sector => {
        for (let i = 1; i <= 8; i++) {
          const diente = sector + i;
          // Usar $set para asegurar reactividad
          this.$set(this.odontograma, diente + '_odo', '');
          this.$set(this.odontograma, diente + '_cart_odo', null);
          this.$set(this.odontoCart, diente, []);
        }
      });
      
      console.log('Odontograma limpio creado:', this.odontograma);
    },
    _handleServicioChange(a) {
      this.cart.cant_sca = 1;
      this.cart.precio_sca = a.precio_ser;
      this.cart.desc_ser = a.desc_ser;
    },
    _addCarritoDiente() {
      let err = null;
      if (!this.cart.id_ser_sca) {
        err = "Selecciona un servicio para agregar al carrito";
      } else if (!this.cart.cant_sca || this.cart.cant_sca < 1) {
        err = "La cantidad debe ser por lo menos 1";
      } else if (!this.cart.precio_sca || this.cart.precio_sca <= 0) {
        err = "El precio no puede ser negativo";
      }
      
      if (err) {
        this.$emit("msg", err);
        return false;
      }

      if (!this.odontoCart[this.dienteToAdd]) {
        this.odontoCart[this.dienteToAdd] = [];
      }

      this.odontoCart[this.dienteToAdd].push({
        id_pac_sca: this.paciente,
        id_ser_sca: this.cart.id_ser_sca,
        cant_sca: this.cart.cant_sca,
        precio_sca: this.cart.precio_sca,
        desc_ser: this.cart.desc_ser,
        diente: this.dienteToAdd
      });

      // Sincronizar con el odontograma
      this.$set(this.odontograma, this.dienteToAdd + '_cart_odo', 
        JSON.stringify(this.odontoCart[this.dienteToAdd]));

      this._getTotalCart();
      this.$emit("msg", "Servicio añadido al diente " + this.dienteToAdd);
      this._limpiarCart();
    },
    _limpiarCart() {
      Object.keys(this.cart).forEach((e) => {
        this.cart[e] = null;
      });
    },
    _deleteCarrito(idx) {
      this.odontoCart[this.dienteToAdd].splice(idx, 1);
      
      // Sincronizar con el odontograma
      this.$set(this.odontograma, this.dienteToAdd + '_cart_odo', 
        this.odontoCart[this.dienteToAdd].length > 0 
          ? JSON.stringify(this.odontoCart[this.dienteToAdd]) 
          : null);
      
      this._getTotalCart();
      this.$emit("msg", "Servicio eliminado");
      this._limpiarCart();
    },
    _updateServiceQuantity(idx) {
      // Validar que la cantidad sea válida
      if (this.odontoCart[this.dienteToAdd][idx].cant_sca < 1) {
        this.odontoCart[this.dienteToAdd][idx].cant_sca = 1;
      }
      
      // Sincronizar con el odontograma
      this.$set(this.odontograma, this.dienteToAdd + '_cart_odo', 
        JSON.stringify(this.odontoCart[this.dienteToAdd]));
      
      this._getTotalCart();
      this.$emit("msg", "Cantidad actualizada");
    },
    _getTotalCart() {
      let cartToAdd = [];
      Object.keys(this.odontoCart).forEach(diente => {
        if (this.odontoCart[diente] && this.odontoCart[diente].length >= 1) {
          cartToAdd = cartToAdd.concat(
            this.odontoCart[diente].map(item => ({
              ...item,
              diente: diente
            }))
          );
        }
      });
      this.finalCart = cartToAdd;
    },
    _getOdontograma() {
      if (this.odontogramaToEdit && this.odontogramaToEdit.id_odo) {
        console.log('Cargando odontograma:', this.odontogramaToEdit);
        this._getThings(
          "odontograma/" + this.odontogramaToEdit.id_odo,
          "odontograma"
        );
      }
    },
    _handleOdontogramaLoaded(odontogramaData) {
      console.log('Procesando odontograma para popular el carrito:', odontogramaData.id_odo);
      
      const newOdontoCart = {};
      
      ['si', 'sd', 'ii', 'id'].forEach(sector => {
        for (let i = 1; i <= 8; i++) {
          const diente = sector + i;
          const cartKey = diente + '_cart_odo';
          
          this.$set(newOdontoCart, diente, []);
          
          if (odontogramaData[cartKey] && typeof odontogramaData[cartKey] === 'string' && odontogramaData[cartKey].startsWith('[')) {
            try {
              const carritoData = JSON.parse(odontogramaData[cartKey]);
              this.$set(newOdontoCart, diente, carritoData);
            } catch (e) {
              console.error('Error parsing cart for', diente, e);
            }
          }
        }
      });
      
      this.odontoCart = newOdontoCart;
      this._getTotalCart();
      
      console.log('Carrito del odontograma cargado:', this.odontoCart);
    },
  },
  created() {
    this._createCleanOdontograma();
  },
  watch: {
    odontograma: {
      deep: true,
      handler(newVal) {
        if (
          newVal &&
          newVal.id_odo &&
          this.odontogramaToEdit &&
          newVal.id_odo === this.odontogramaToEdit.id_odo
        ) {
          this._handleOdontogramaLoaded(newVal);
        }
      },
    },
    value: {
      immediate: true,
      handler(newVal) {
        console.log('value changed:', newVal);
        this.showDialogForm = newVal;
      }
    },
    odontogramaToEdit: {
      immediate: true,
      handler(newVal) {
        console.log('odontogramaToEdit changed:', newVal);
        if (newVal && newVal.id_odo) {
          this._getOdontograma();
        } else {
          this._createCleanOdontograma();
        }
      }
    },
    showDialogForm(newVal) {
      console.log('showDialogForm changed:', newVal);
      this.$emit("input", newVal);
      if (!newVal) {
        this._resetForm();
      }
    },
    showDialogAddToCart(a) {
      if (!a) {
        this.dienteToAdd = null;
        this._limpiarCart();
      }
    },
    dienteToAdd(a) {
      if (a) this.showDialogAddToCart = true;
    },
  },
  computed: {
    total() {
      let subtotal = 0;
      this.finalCart.forEach((fc) => {
        subtotal = subtotal + fc.cant_sca * fc.precio_sca;
      });
      console.log("subtotal: " + subtotal);
      return subtotal;
    },
  },
};
</script>

<style scoped>
.cart-service {
  display: block;
  background-color: #e3f2fd;
  color: #1976d2;
  padding: 4px 8px;
  margin: 4px 0;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  border-left: 3px solid #2196f3;
}

.mb8 {
  margin-bottom: 8px;
}

.mt24 {
  margin-top: 24px;
}
</style>